<template>
  <div class="profile">
    <v-tabs v-model="tab" centered icons-and-text class="d-flex justify-center">
      <v-tab href="#profile" class="tab-clr">
        PROFILE
        <v-icon>mdi-account-circle-outline</v-icon>
      </v-tab>

      <v-tab href="#roles" class="tab-clr">
        ROLES
        <v-icon>mdi-svg</v-icon>
      </v-tab>

      <v-tab
        href="#history"
        class="tab-clr"
        @click="getPasswordChangeHistory()"
      >
        HISTORY
        <v-icon>mdi-clock-check-outline</v-icon>
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items v-model="tab">
      <v-tab-item
        value="profile"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-card flat>
          <v-row class="pt-4">
            <v-col cols="12" md="5">
              <div>
                <div v-if="!isShow.information">
                  <h6 class="font-weight-bold pb-2">
                    Basic Information
                    <v-btn
                      class="float-right"
                      text
                      @click="updateDetails('information', true)"
                    >
                      Edit
                    </v-btn>
                  </h6>
                  <h6 class="font-weight-bold">
                    Name:
                    <span class="font-weight-medium"
                      >{{ getUserData.user.name.given }}
                      {{ getUserData.user.name.surname }}</span
                    >
                  </h6>
                  <h6 class="font-weight-bold">
                    Email:
                    <span class="font-weight-medium">{{
                      getUserData.user.email
                    }}</span>
                  </h6>
                </div>
                <div class="update-form pa-8" v-else>
                  <h6 class="font-weight-bold pb-4">
                    Basic Information
                    <span class="float-right font-weight-medium"
                      ><v-icon @click="updateDetails('information', false)"
                        >mdi-close-circle</v-icon
                      >
                    </span>
                  </h6>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">First Name</h4>
                    <v-text-field
                      v-model="editProfile.name.given"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">Last Name</h4>
                    <v-text-field
                      v-model="editProfile.name.surname"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">Email</h4>
                    <v-text-field
                      v-model="editProfile.email"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="mt-2 text-right">
                    <v-btn
                      depressed
                      medium
                      class="mr-1"
                      @click="updateDetails('information', false)"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      medium
                      color="rgb(0, 102, 124)"
                      class="white--text"
                      @click="updateProfile()"
                    >
                      Update
                    </v-btn>
                  </div>
                </div>
              </div>
              <div>
                <div v-if="!isShow.password">
                  <h6 class="font-weight-bold pt-4">
                    Password: <span class="font-weight-medium"> **********</span
                    ><span class="float-right font-weight-medium"
                      ><v-btn text @click="updateDetails('password', true)">
                        Edit
                      </v-btn>
                    </span>
                  </h6>
                </div>
                <div class="update-form pa-8 my-3 pwd-form" v-else>
                  <h6 class="font-weight-bold pb-4">
                    Password
                    <span class="float-right font-weight-medium"
                      ><v-icon @click="updateDetails('password', false)"
                        >mdi-close-circle</v-icon
                      >
                    </span>
                  </h6>
                  <v-form ref="form" v-model="valid">
                    <div class="py-2">
                      <h4 class="pb-2 grey--text">Current Password</h4>
                      <v-text-field
                        v-model="currentPwd"
                        outlined
                        dense
                        type="password"
                        required
                      ></v-text-field>
                    </div>
                    <div class="py-2">
                      <h4 class="pb-2 grey--text">Enter new password</h4>
                      <v-text-field
                        v-model="pw1"
                        outlined
                        dense
                        type="password"
                        :rules="pwdRules"
                        :class="validationRes.valid == false ? 'error--text validatepwd' : 'validatepwd'"
                      ></v-text-field>
                      <p v-if="(validationRes.errors.length > 0) || (validationRes.valid == false)" class="error--text error-msg">{{messageValidationerror}}</p>
                    </div>
                    <div class="py-2">
                      <h4 class="pb-2 grey--text">Re-enter new password</h4>
                      <v-text-field
                        v-model="pw2"
                        class="password-rules"
                        outlined
                        dense
                        type="password"
                        :rules="pwdConfirm"
                      ></v-text-field>
                    </div>
                    <div class="mt-2 text-right">
                      <v-btn
                        depressed
                        medium
                        class="mr-1"
                        @click="updateDetails('password', false)"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        depressed
                        medium
                        color="rgb(0, 102, 124)"
                        class="white--text"
                        @click="updatePassword()"
                        :disabled="(!valid || !validationRes.valid) ? true : false"
                      >
                        Update
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2"> </v-col>
            <v-col cols="12" md="5">
              <div>
                <div v-if="!isShow.addressUpdate">
                  <h6 class="font-weight-bold pb-2">
                    Address
                    <span class="float-right font-weight-medium"
                      ><v-btn
                        text
                        @click="updateDetails('addressUpdate', true)"
                      >
                        Edit
                      </v-btn>
                    </span>
                  </h6>
                  <div
                    v-for="(address, index) in getUserData.user.addresses"
                    :key="index"
                  >
                    <h6
                      class="mb-0"
                      v-for="(street, i) in address.streets"
                      :key="i"
                    >
                      <span>{{ street }}</span>
                    </h6>
                    <h6 class="mb-0">
                      <span>{{ address.city }}</span>
                    </h6>
                    <h6 class="mb-0">
                      <span>{{ address.state }}, {{ address.postal }}</span>
                    </h6>
                    <h6 class="mb-0">
                      <span>{{ address.country | getCountryName }}</span>
                    </h6>
                  </div>
                </div>
                <div class="update-form pa-8 my-3" v-else>
                  <h6 class="font-weight-bold pb-4">
                    Address
                    <span class="float-right font-weight-medium"
                      ><v-icon @click="updateDetails('addressUpdate', false)"
                        >mdi-close-circle</v-icon
                      >
                    </span>
                  </h6>
                  <div
                    v-for="(address, index) in editProfile.addresses"
                    :key="index"
                  >
                    <div
                      class="py-2"
                      v-for="(street, i) in address.streets"
                      :key="i"
                    >
                      <h4 class="pb-2 grey--text">
                        Street Address<span v-if="i != 0">{{ i + 1 }}</span>
                      </h4>
                      <v-text-field
                        v-model="address.streets[i]"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="py-2">
                      <h4 class="pb-2 grey--text">City</h4>
                      <v-text-field
                        v-model="address.city"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <v-row class="py-2">
                      <v-col md="6">
                        <h4 class="pb-2 grey--text">State / Province</h4>
                        <v-text-field
                          v-model="address.state"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <h4 class="pb-2 grey--text">Zip</h4>
                        <v-text-field
                          v-model="address.postal"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <div class="py-2">
                      <h4 class="pb-2 grey--text">Country</h4>
                      <v-select
                        v-model="editProfile.addresses[index].country"
                        :items="countriesList.countries"
                        item-text="name"
                        item-value="code"
                        outlined
                        dense
                      ></v-select>
                    </div>
                  </div>
                  <div class="mt-2 text-right">
                    <v-btn
                      depressed
                      medium
                      class="mr-1"
                      @click="updateDetails('addressUpdate', false)"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      medium
                      color="rgb(0, 102, 124)"
                      class="white--text"
                      @click="updateProfile()"
                    >
                      Update
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="12" md="5">
              <div v-if="!isShow.questionsUpdate">
                <v-row>
                  <v-col class="checklist pt-0">
                    <v-checkbox
                      v-model="mask"
                      label=" Mask/Unmask security answers"
                      color="black"
                      hide-details
                      :ripple="false"
                      class="mt-0"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <h6 class="font-weight-bold py-2">
                  Challenge Questions
                  <span class="float-right font-weight-medium"
                    ><v-btn
                      text
                      @click="updateDetails('questionsUpdate', true)"
                    >
                      Edit
                    </v-btn>
                  </span>
                </h6>
                <h6
                  class="font-weight-bold"
                  v-for="(question, index) in userSecurityQuestions"
                  :key="index"
                >
                  {{ index + 1 }}:
                  <span class="font-weight-medium">{{
                    question.question.id
                      | getQuestionByID(
                        securityQuestions,
                        getUserData.user.language
                      )
                  }}</span>
                </h6>
              </div>
              <div class="update-form pa-8 my-3" v-else>
                <v-checkbox
                  v-model="mask"
                  label=" Mask/Unmask security answers"
                  color="black"
                  hide-details
                  :ripple="false"
                  class="mt-0 mb-3"
                >
                </v-checkbox>
                <h6 class="font-weight-bold pb-4">
                  Challenge Questions
                  <span class="float-right font-weight-medium"
                    ><v-icon @click="updateDetails('questionsUpdate', false)"
                      >mdi-close-circle</v-icon
                    >
                  </span>
                </h6>
                <div
                  class="py-2"
                  v-for="(question, index) in userSecurityQuestions"
                  :key="index"
                >
                  <h4 class="pb-2 grey--text">
                    Challenge question {{ index + 1 }}
                  </h4>
                  <v-select
                    v-model="question.question.id"
                    :items="challengeQuestionSet[index]"
                    item-text="question[0].text"
                    item-value="id"
                    outlined
                    dense
                    required
                  ></v-select>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">Answer</h4>
                    <v-text-field
                      v-model="question.answer"
                      :type="mask ? 'password' : 'text'"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </div>
                <div class="mt-2 text-right">
                  <v-btn
                    depressed
                    medium
                    class="mr-1"
                    @click="updateDetails('questionsUpdate', false)"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    depressed
                    medium
                    color="rgb(0, 102, 124)"
                    class="white--text"
                    @click="updateChallengeQuestion()"
                  >
                    Update
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2"> </v-col>
            <v-col cols="12" md="5">
              <div>
                <div v-if="!isShow.contactUpdate">
                  <h6 class="font-weight-bold pb-2">
                    Phone/Fax
                    <span class="float-right font-weight-medium"
                      ><v-btn
                        text
                        @click="updateDetails('contactUpdate', true)"
                      >
                        Edit
                      </v-btn>
                    </span>
                  </h6>
                  <h6 class="font-weight-bold">
                    Office:
                    <span class="font-weight-medium">{{
                      getUserData.user.phones | getNumber("main")
                    }}</span>
                  </h6>
                  <h6 class="font-weight-bold">
                    Mobile:
                    <span class="font-weight-medium">{{
                      getUserData.user.phones | getNumber("mobile")
                    }}</span>
                  </h6>
                  <h6 class="font-weight-bold">
                    Phone/Fax:
                    <span class="font-weight-medium">{{
                      getUserData.user.phones | getNumber("fax")
                    }}</span>
                  </h6>
                </div>
                <div class="update-form pa-8 my-3" v-else>
                  <h6 class="font-weight-bold pb-4">
                    Phone/Fax
                    <span class="float-right font-weight-medium"
                      ><v-icon @click="updateDetails('contactUpdate', false)"
                        >mdi-close-circle</v-icon
                      >
                    </span>
                  </h6>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">*Office</h4>
                    <v-text-field
                      :value="getUserData.user.phones | getNumber('main')"
                      outlined
                      dense
                      @input="
                        setUserDetails(
                          $event,
                          'phones',
                          'type',
                          'main',
                          'number'
                        )
                      "
                    ></v-text-field>
                  </div>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">Mobile</h4>
                    <v-text-field
                      :value="getUserData.user.phones | getNumber('mobile')"
                      outlined
                      dense
                      @input="
                        setUserDetails(
                          $event,
                          'phones',
                          'type',
                          'mobile',
                          'number'
                        )
                      "
                    ></v-text-field>
                  </div>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">Phone/Fax</h4>
                    <v-text-field
                      :value="getUserData.user.phones | getNumber('fax')"
                      outlined
                      dense
                      @input="
                        setUserDetails(
                          $event,
                          'phones',
                          'type',
                          'fax',
                          'number'
                        )
                      "
                    ></v-text-field>
                  </div>
                  <div class="mt-2 text-right">
                    <v-btn
                      depressed
                      medium
                      class="mr-1"
                      @click="updateDetails('contactUpdate', false)"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      medium
                      color="rgb(0, 102, 124)"
                      class="white--text"
                      @click="updateProfile()"
                    >
                      Update
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row class="my-0">
            <v-col cols="12" md="5">
              <div>
                <div v-if="!isShow.timezoneUpdate">
                  <h6 class="font-weight-bold pb-2">
                    Timezone and Language
                    <span class="float-right font-weight-medium"
                      ><v-btn
                        text
                        @click="updateDetails('timezoneUpdate', true)"
                      >
                        Edit
                      </v-btn>
                    </span>
                  </h6>
                  <h6 class="font-weight-bold">
                    Timezone:
                    <span class="font-weight-medium">{{
                      getUserData.user.timezone | getTimezone
                    }}</span>
                  </h6>
                  <h6 class="font-weight-bold">
                    Language:
                    <span class="font-weight-medium">{{
                      getUserData.user.language | getlanguages
                    }}</span>
                  </h6>
                </div>
                <div class="update-form pa-8 my-3" v-else>
                  <h6 class="font-weight-bold pb-4">
                    Timezone and Language
                    <span class="float-right font-weight-medium"
                      ><v-icon @click="updateDetails('timezoneUpdate', false)"
                        >mdi-close-circle</v-icon
                      >
                    </span>
                  </h6>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">Timezone</h4>
                    <v-select
                      v-model="editProfile.timezone"
                      :items="timeZonesList"
                      item-text="name"
                      item-value="id"
                      outlined
                      dense
                    ></v-select>
                  </div>
                  <div class="py-2">
                    <h4 class="pb-2 grey--text">Language</h4>
                    <v-select
                      v-model="editProfile.language"
                      :items="languagesList"
                      item-text="title"
                      item-value="language"
                      outlined
                      dense
                    ></v-select>
                  </div>
                  <div class="mt-2 text-right">
                    <v-btn
                      depressed
                      medium
                      class="mr-1"
                      @click="updateDetails('timezoneUpdate', false)"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      medium
                      color="rgb(0, 102, 124)"
                      class="white--text"
                      @click="updateProfile()"
                    >
                      Update
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2"> </v-col>
            <v-col cols="12" md="5"> </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <v-tab-item
        value="roles"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-card flat>
          <v-row class="pt-4">
            <v-col cols="12" md="6">
              <div>
                <h6 class="font-weight-bold pb-2">Assigned Roles</h6>
                <v-divider></v-divider>
                <div v-for="(role, i) in getUserData.roleList" :key="i">
                  <h6 class="mb-1 mt-3">
                    <span>{{ role }}</span>
                  </h6>
                  <v-divider></v-divider>
                </div>
              </div>
            </v-col>
            <v-col cols="6"> </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
      <v-tab-item
        value="history"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-card flat>
          <v-row class="my-0">
            <v-col cols="12" md="6">
              <div>
                <h6 class="font-weight-bold pb-2">My Status History</h6>
                <v-divider></v-divider>
                <h6 class="font-weight-bold mb-4 mt-2">
                  Last Login:
                  <span class="font-weight-medium">{{
                    getUserData.user.lastLoginDate
                      | formatDate(getUserData.user.timezone)
                  }}</span>
                </h6>
                <h6 class="font-weight-bold">
                  active:
                  <span class="font-weight-medium">{{
                    getUserData.user.activatedDate
                      | formatDate(getUserData.user.timezone)
                  }}</span>
                </h6>
                <h6 class="font-weight-bold">
                  pending:
                  <span class="font-weight-medium">{{
                    getUserData.user.activatedDate
                      | formatDate(getUserData.user.timezone)
                  }}</span>
                </h6>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pl-10">
              <h6 class="font-weight-bold pb-2">Password change log</h6>
              <v-divider></v-divider>
              <div v-if="pwdChangeHistory.length > 0">
                <v-data-table
                  :headers="historyHeaders"
                  :items="pwdChangeHistory"
                  :hide-default-footer="true"
                  :disable-pagination="false"
                  :page="destination_page"
                  class="elevation-1 border-none"
                >
                  <template v-slot:[`item.creation`]="{ item }">
                    {{ item.creation | formatDate(getUserData.user.timezone) }}
                  </template>
                  <template v-slot:[`item.eventType`]="{ item }">
                    {{ item.eventType.toLowerCase() }}
                  </template>
                </v-data-table>
              </div>
              <h6 class="mt-2" v-else><span>No details available.</span></h6>
              <v-pagination
                flat
                v-model="destination_page"
                color="rgb(0, 102, 124)"
                :length="
                  pwdChangeHistory.length > 0
                    ? Math.ceil(pwdChangeHistory.length / 10)
                    : 1
                "
                :total-visible="5"
                class="float-right"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-snackbar
      :timeout="5000"
      :value="profileUpdatedFlage"
      color="rgb(0, 102, 124)"
      absolute
      top
    >
      Updated Profile successfully
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable */
// eslint-disable-next-line
import Countries from "@/plugins/factory/Countries";
import Timezones from "@/plugins/factory/Timezones";
import { languages } from "@/plugins/factory/Language";
import _ from "lodash";
import Vue from "vue";

export default {
  beforeMount() {
    this.$store.dispatch("getPasswordPolicySecured");
    this.$store.dispatch("getUserSecurityQuestions");
    this.$store.dispatch("getSecurityQuestions");
  },
  data() {
    return {
      destination_page: 1,
      mask: true,
      tab: null,
      isShow: {
        information: false,
        password: false,
        addressUpdate: false,
        questionsUpdate: false,
        contactUpdate: false,
        timezoneUpdate: false,
      },
      isUpdate: false,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      editProfile: {},
      challengeQuestionSet: [],
      timeZonesList: Timezones.timezones,
      languagesList: languages,
      countriesList: Countries,
      currentPwd: "",
      pw1: "",
      pw2: "",
      pwdConfirm: [
        (v) => !!v || "Confirm password",
        (v) => v === this.pw1 || "Passwords do not match",
      ],
      valid: true,
      historyHeaders: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "creation",
        },
        {
          text: "Event Type",
          align: "start",
          sortable: false,
          value: "eventType",
        },
        {
          text: "Notes",
          align: "start",
          sortable: false,
          value: "notes",
        },
      ],
      rules: [],
      requiredNumberOfCharClasses: 1,
      messageValidationerror: null,
      minLength: 8,
      validationRes: { valid:true, errors:[] },
      lengthCondition: {}
    };
  },
  computed: {
    getUserData() {
      return this.$store.getters.getUserInfo;
    },
    userSecurityQuestions() {
      return this.$store.getters.getUserSecurityQuestions;
    },
    securityQuestions() {
      return this.$store.getters.getSecurityQuestions;
    },
    profileUpdatedFlage() {
      return this.$store.getters.getProfileUpdatedFlage;
    },
    pwdChangeHistory() {
      return this.$store.getters.getPwdChangeHistory;
    },
    passwordRules() {
      return this.$store.getters.getPwdRules;
    },
    pwdRules() {
      if (this.$store.getters.getPwdRules.length > 0) {
        this.rules = [];
        const passwordRulesList = this.$store.getters.getPwdRules[0];
        const passwordLength = this.$store.getters.getPwdRules[1].min;
        this.requiredNumberOfCharClasses = passwordRulesList.requiredNumberOfCharClasses;
        this.minLength = this.$store.getters.getPwdRules[1].min;

        if(passwordRulesList.allowUpperChars) {
          this.rules.push({ message:"One uppercase letter required.",  regex:/[A-Z]+/ })
        }
         if(passwordRulesList.allowLowerChars) {
          this.rules.push({ message:'One lowercase letter required.', regex:/[a-z]+/ })
        }
        if(passwordRulesList.allowNumChars) {
          this.rules.push({ message:"One number required.", regex:/[0-9]+/ })
        }
        if(passwordRulesList.allowSpecialChars) {
          this.rules.push({ message:"secial characters minimum.", regex:/[!#$%&'*+/=@]+/ })
        }
        if (
          passwordRulesList.allowUpperChars &&
          passwordRulesList.allowLowerChars &&
          passwordRulesList.allowNumChars &&
          passwordRulesList.allowSpecialChars
        ) {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Number, Lower Case Letters, Upper Case Letters, special symbol(ex: !,*,+)`
          
          } else if (
          passwordRulesList.allowUpperChars &&
          passwordRulesList.allowLowerChars &&
          passwordRulesList.allowNumChars &&
          !passwordRulesList.allowSpecialChars
        ) {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Number, Lower Case Letters, Upper Case Letters`
          
        } else {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Lower Case Letters, Upper Case Letters`;
         
        }
        return [
          v => (v && v.length >= this.minLength) || `Password must be greater than ${passwordLength} characters.`
        ]
      }else {
        return []
      }
    },
  },
  methods: {
    updateDetails(key, flag) {
      this.editProfile = Object.assign({}, this.getUserData.user);
      this.currentPwd = "";
      this.pw1 = "";
      this.pw2 = "";
      this.isShow = _.mapValues(this.isShow, () => false);
      this.isShow[key] = flag;
      this.validationRes= { valid:true, errors:[] };
    },
    updateProfile() {
      var payload = {
        id: this.editProfile.id,
        user: this.editProfile,
      };
      this.$store.commit("SET_TIMEZONE_USER_INFO", this.editProfile.timezone);
      this.$store.dispatch("UpdateUserProfile", payload);
    },
    setUserDetails(newValue, mainProperty, findKey, findValue, updateKey) {
      if (
        this.editProfile[mainProperty].find(
          (item) => item[findKey] == findValue
        )
      ) {
        this.editProfile[mainProperty].forEach((element) => {
          if (element[findKey] == findValue) {
            element[updateKey] = newValue;
          }
        });
      } else {
        this.editProfile[mainProperty].push({
          type: findValue,
          number: newValue,
        });
      }
    },
    updateChallengeQuestion() {
      var params = {
        questions: this.userSecurityQuestions,
        version: "1",
        id: this.getUserData.user.id,
      };
      this.$store.dispatch("updateUserSecurityQuestionAccount", params);
    },
    updatePassword() {
      const pwdParams = {
        version: "1",
        username: this.getUserData.user.username,
        currentPassword: this.currentPwd,
        password: this.pw1,
        passwordPolicy: this.getUserData.organization.passwordPolicy,
        authenticationPolicy:
          this.getUserData.organization.authenticationPolicy,
      };
      this.$store.dispatch("updateUserPassword", {
        id: this.getUserData.user.id,
        pwdParams: pwdParams,
      });
    },
    getPasswordChangeHistory() {
      this.$store.dispatch(
        "getPasswordChangeHistory",
        this.getUserData.user.id
      );
    }
  },
  watch: {
    pw1(val) {
      let errors = []
			for (let condition of this.rules) {
				if (!condition.regex.test(val)) {
					errors.push(condition.message)
				}
			}
			if ((this.rules.length - errors.length ) >= this.requiredNumberOfCharClasses) {
				this.validationRes = { valid:true, errors:[] }
			} else {
				this.validationRes = { valid:false, errors }
			}
    },
    profileUpdatedFlage(val) {
      if (val) {
        this.isShow = _.mapValues(this.isShow, () => false);
        let vm = this;
        setTimeout(function () {
          vm.$store.commit("SET_PROFILE_UPDATED_FLAG", false);
        }, 5000);
      }
    },
    securityQuestions(val) {
      this.challengeQuestionSet[0] = val.slice(1, 4);
      this.challengeQuestionSet[1] = val.slice(4, val.length);
    },
  },
  filters: {
    getNumber(phones, type) {
      return phones.find((item) => item.type === type)
        ? phones.find((item) => item.type === type).number
        : "";
    },
    getCountryName(code) {
      return Countries.getCountryByCode(code)
        ? Countries.getCountryByCode(code).name
        : "";
    },
    getTimezone(id) {
      return Timezones.getTimezoneById(id);
    },
    getlanguages(code) {
      return languages.find((item) => item.language === code)
        ? languages.find((item) => item.language === code).title
        : "";
    },
    getQuestionByID(qid, questions, languageCode) {
      const question = questions.find((item) => item.id === qid);
      if (question) {
        return question.question.find((q) => q.lang === languageCode)
          ? question.question.find((q) => q.lang === languageCode).text
          : question.question.find((q) => q.lang === 'en').text; // default 'en'
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.v-application a.tab-clr {
  color: rgba(0, 0, 0, 0.25) !important;
  font-size: 11px;
  font-weight: 700;
}
.v-application
  .theme--light.v-tabs
  > .v-tabs-bar
  .v-tab:not(.v-tab--active)
  > .v-icon {
  color: rgba(0, 0, 0, 0.25) !important;
}
.v-application a.tab-clr.v-tab--active {
  color: #00667c !important;
}
.v-tabs-slider {
  color: #fff;
}
.profile .theme--light.v-tabs > .v-tabs-bar,
.profile .theme--light.v-card {
  background: #f9f9f9;
}
.profile h6 {
  color: #343534;
  letter-spacing: 1.6px;
  font-size: 1.25em;
}
.profile h6 span {
  color: #929292;
  font-size: 0.8em;
  letter-spacing: 1px;
}
.checklist .theme--light.v-label {
  color: #929292;
  font-size: 1em;
  letter-spacing: 1px;
}
.update-form {
  background: #d4e2e6;
}
.update-form .v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #fff;
}
.update-form .v-text-field__details {
  display: none;
}
.pwd-form .v-text-field__details {
  display: block;
  padding: 0 !important;
}
.pwd-form .v-text-field__details .v-messages__message {
  line-height: 20px;
  font-size: 14px;
}
.border-none {
  border: none;
}
.pwd-form .v-messages__message {
  padding: 15px !important;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.error-msg {
  padding: 15px !important;
border-radius: 4px;
margin-bottom: 0 !important;
margin-top: -15px;
font-size: 14px !important;
}
.validatepwd .v-messages__message {
  border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/partials/ProfileTabs.vue